import { ThumbUp } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useConfirmationDialog } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { MessageForm } from '../MessageForm/MessageForm';
import { I18nNamespace } from '~/common/types';

export interface AcceptButtonProps {
  loading?: boolean;
  disabled?: boolean;
  onSubmit: (data: { message: Union.Nullable<string> }) => Promise<void>;
}

export const AcceptButton = ({ loading, disabled, onSubmit }: AcceptButtonProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'NegotiatedQuoteWidget' });
  const { confirm } = useConfirmationDialog();

  return (
    <Button
      loading={loading}
      disabled={disabled}
      loadingPosition="end"
      endIcon={<ThumbUp />}
      variant="contained"
      color="success"
      onClick={confirm(onSubmit, {
        title: t('acceptDialog.title'),
        maxWidth: 'md',
        content: <MessageForm i18nKeyPrefix={'NegotiatedQuoteWidget.acceptDialog'} />,
        confirm: {
          children: t('acceptDialog.apply'),
          color: 'primary',
        },
        cancel: {
          children: t('acceptDialog.cancel'),
        },
      })}
    >
      {t('acceptButton')}
    </Button>
  );
};
